"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(["\n    margin-bottom: ", "rem;\n"], ["\n    margin-bottom: ", "rem;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n    display: ", ";\n    padding-right: ", "rem;\n"], ["\n    display: ", ";\n    padding-right: ", "rem;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _functions = require("../../functions");

var _label = require("./label");

var _label2 = _interopRequireDefault(_label);

var _inputError = require("./inputError");

var _inputError2 = _interopRequireDefault(_inputError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledInput = _styledComponents2.default.input(_templateObject, function (props) {
    return props.theme.input.margin;
});
var ButtonWapper = _styledComponents2.default.div(_templateObject2, function (props) {
    return props.inlineRadioButtons ? "inline-block" : "block";
}, function (props) {
    return props.theme.input.margin;
});

var RadioField = function RadioField(_ref) {
    var options = _ref.options,
        input = _ref.input,
        type = _ref.type,
        name = _ref.name,
        onChange = _ref.onChange,
        label = _ref.label,
        readOnly = _ref.readOnly,
        error = _ref.error,
        inlineRadioButtons = _ref.inlineRadioButtons,
        rest = _objectWithoutProperties(_ref, ["options", "input", "type", "name", "onChange", "label", "readOnly", "error", "inlineRadioButtons"]);

    var handleChange = function handleChange(event) {
        onChange({
            name: name,
            value: event.target.value
        });
    };
    return _react2.default.createElement(
        "div",
        null,
        label && _react2.default.createElement(
            _label2.default,
            _extends({ name: name, label: label }, rest),
            label
        ),
        options && options.map(function (radio, index) {
            return _react2.default.createElement(
                ButtonWapper,
                {
                    key: index,
                    inlineRadioButtons: inlineRadioButtons
                },
                _react2.default.createElement(StyledInput, _extends({
                    type: "radio",
                    name: name
                }, rest, {
                    value: radio.value,
                    onChange: handleChange
                })),
                " " + radio.text
            );
        }),
        _react2.default.createElement(_inputError2.default, { error: error })
    );
};

RadioField.displayName = "RadioField";

RadioField.propTypes = {
    name: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.any,
        text: _propTypes2.default.string.isRequired
    })),
    size: _propTypes2.default.string,
    expanded: _propTypes2.default.bool,
    inlineLabel: _propTypes2.default.bool,
    inlineRadioButtons: _propTypes2.default.bool,
    input: _propTypes2.default.object,
    type: _propTypes2.default.string,
    label: _propTypes2.default.string,
    readOnly: _propTypes2.default.bool,
    error: _propTypes2.default.string
};
RadioField.defaultProps = {
    size: "default",
    expanded: false,
    inlineLabel: true,
    inlineRadioButtons: false,
    type: "text",
    readOnly: false,
    error: ""
};
exports.default = RadioField;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/form/radio.js
// module id = 1003
// module chunks = 95715928098905 168707334958949